import React from 'react';
import { Controller, Control } from 'react-hook-form';
import { FormValues } from '../../type';
import styles from './SmallTextField.module.scss';

interface SmallTextFieldProps {
  control: Control<FormValues>;
  name: 'chronic_diseases' | any;
  placeholder?: string;
}

const SmallTextField: React.FC<SmallTextFieldProps> = ({ control, name,     
  placeholder }) => {
  console.log(control, "control")
  return (
    <div className={styles.symptomsContainer}>
      <Controller
        name={name}
        control={control}
        rules={{
          required: 'Wypełnij to pole',
          minLength: {
            value: 1,
            message: 'Opis powinien mieć co najmniej 1 znaków'
          },
          maxLength: {
            value: 1000,
            message: 'Opis nie może przekraczać 1000 znaków'
          },
          validate: (value) => {
            if (!value.trim()) {
              return 'Opis nie może być pusty';
            }
            return true;
          }
        }}
        render={({ field, fieldState }) => (
          <div>
            <input
              {...field}
              className={`${styles.input} ${fieldState.error ? styles.error : ''}`}
              placeholder={placeholder}
              
            />
            <div className={styles.fieldFooter}>
              {fieldState.error && (
                <span className={styles.errorMessage}>
                  {fieldState.error.message}
                </span>
              )}
             
            </div>
          </div>
        )}
      />
    </div>
  );
};

export default SmallTextField; 